<template>
  <div class="tabs">
    <a
      v-for="(item, i) in list"
      :key="i"
      href="javascript:;"
      :class="{ active: cur === i }"
      @click="
        cur = i
        $emit('change', i, item)
      "
    >
      {{ item.title }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      cur: 0
    }
  }
}
</script>
